import React, { useEffect, useState, MouseEvent } from "react";
import "./Navbar.css";
import { QRCodeSVG } from 'qrcode.react';


import { useSelector } from "react-redux";

import logo from "../../Assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { RiMenu2Line } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { FaCartShopping, FaRegUser } from "react-icons/fa6";
import { RiShoppingBagLine } from "react-icons/ri";
import { MdOutlineClose } from "react-icons/md";
import { FaFacebookF, FaSignOutAlt } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";
import { Autocomplete, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { FaGift } from 'react-icons/fa'; // Gift icon from Font Awesome
import { FaUserCircle, FaSignInAlt, FaClipboardList } from 'react-icons/fa';
import { RiShoppingCartLine } from 'react-icons/ri';
import { FaCashRegister } from 'react-icons/fa';
import { FaShoppingCart, FaBoxOpen } from 'react-icons/fa';
import Badge from "@mui/material/Badge";
import { storeMenuData } from "../../Data/StoreData";
import { useDispatch } from 'react-redux';
import { loadFromStorage, logout } from "../../Slice/Auth.Slice";
import { Customer } from "../../Interface/Login.interface";
import { fetchFailBuyData } from "../../Slice/Buy.Slice";
import { BuyOrders } from "../../Interface/Order.interface";
import { GetBuyOrders } from "../../Action/buy.Actions";
import { AppDispatch } from "../../App/store";
import CustomNavbar from "./CustomNavbar";
import FlagDropdown from "./FlagDropdown";
import CategoryDropdown from "./CategoryDropdown";
import { getStoredAuth, getStoredAuthCus } from "../../StoreData/authUser";
import { FaAndroid, FaApple } from 'react-icons/fa'
import QrCodeModal from "../Model/QrModel";

interface DropdownItem {
  label: string;
  link?: string;
  icon?: React.ReactNode | string;
  img?: string;
  subDropdown?: DropdownItem[];
}

interface Menu {
  key: string;
  label: string;
  link: string;
  icon?: React.ReactNode | string;
  dropdownIcon?: string;
  dropdown?: DropdownItem[];
}

const Navbar: React.FC = () => {
  const cart = useSelector((state: any) => state.cart); // You can type your redux state properly if you have the shape

  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null); // Track which submenu is open
  const [hoveredDropdownItem, setHoveredDropdownItem] = useState<number | null>(null);
  const [showItemsBox, setShowItemsBox] = useState<boolean>(false);
  const [facebookHovered, setFacebookHovered] = useState<boolean>(false);
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);
  const [auth, setAuth] = useState<Customer[]>(getStoredAuthCus());
  const navigate = useNavigate()

  const dispatch = useDispatch<AppDispatch>();

  const { isAuthenticated, user } = useSelector((state: any) => state.auth)
  const { buyDatas, triggerBuyRefresh, needsRefresh } = useSelector((state: any) => state.BuyOrder)


  const stored = localStorage.getItem('auth') ?? '';


  useEffect(() => {
    if (isAuthenticated && Array.isArray(user)) {
      setAuth(user);
    } else if (isAuthenticated && user) {
      setAuth([user]); // If user is a single object, wrap in array
    } else {
      setAuth([]);
    }
  }, [user, isAuthenticated]);







  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1210);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false); // Auto close on tab/desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('auth')
    scrollToTop(); // optional
    setAuth([])
    dispatch(logout())
    dispatch(fetchFailBuyData())
    navigate('/loginSignUp')

  };

  const hiddenOnMobile: string[] = [
    'home',
    'personal',   // I assume 'personal' key is for Personal Care
    'beverages',
    'cooking',
    'shop',
    'household'
  ];

  const { grains, rice, pulses, spicesandNuts, flourandMasalas, oilingredients } = storeMenuData;

  const menus: Menu[] = [
    {
      key: 'home',
      label: 'HOME',
      link: '/',
      icon: '🏠',
      dropdownIcon: '▼',
      dropdown: [
        {
          label: 'Specials',
          link: '/special',
          icon: '🎉',
        },
        {
          label: 'Cart',
          link: '/cart',
          icon: '🛒',
        },
        {
          label: 'Checkout',
          link: '/orderTracking',
          icon: '💳',
        },

      ],
    },
    {
      key: 'cooking', label: 'Cooking Materials', link: '/', dropdownIcon: '▼',
      dropdown: [
        { label: 'Grains And Rice', link: '/special', img: rice },
        { label: 'Pulses', link: '/special', img: pulses },
        { label: 'Spices & Nuts', link: '/special', img: spicesandNuts },
        { label: 'Flour & Masalas', link: '/special', img: flourandMasalas },
        { label: 'Oil & Condiments', link: '/special', img: oilingredients },
        { label: 'Ready for Cook', link: '/special', img: rice },
        { label: 'Diary Products', link: '/special', img: rice },
        { label: 'Other ingredients', link: '/special', img: rice },
      ]
    },
    {
      key: 'shop', label: 'Beverages Mix & Snacks', link: '/', dropdownIcon: '▼',
      dropdown: [
        { label: 'Tea & Coffee', link: '/special', img: 'https://via.placeholder.com/150?text=Tea+Coffee' },
        { label: 'Health Drinks', link: '/special', img: 'https://via.placeholder.com/150?text=Health+Drinks' },
        { label: 'Snacks', link: '/special', img: 'https://via.placeholder.com/150?text=Health+Drinks' },
        { label: 'Biscuits', link: '/special', img: 'https://via.placeholder.com/150?text=Health+Drinks' },
      ]
    },
    {
      key: 'personal', label: 'Personal Care', link: '/', dropdownIcon: '▼',
      dropdown: [
        { label: 'Oral Care', link: '/special', img: 'https://via.placeholder.com/150?text=Oral+Care' },
        { label: 'Body Care', link: '/special', img: 'https://via.placeholder.com/150?text=Body+Care' },
        { label: 'Hair Care', link: '/special', img: 'https://via.placeholder.com/150?text=Body+Care' },
        { label: 'Face Care', link: '/special', img: 'https://via.placeholder.com/150?text=Body+Care' },
        { label: 'Baby Care', link: '/special', img: 'https://via.placeholder.com/150?text=Body+Care' },
        { label: 'Shaving & Hair Removal', link: '/special', img: 'https://via.placeholder.com/150?text=Body+Care' },
        { label: 'Feminine Hygiene', link: '/special', img: 'https://via.placeholder.com/150?text=Body+Care' },
      ]
    },
    {
      key: 'household', label: 'Household Care & Cleaning', link: '/', dropdownIcon: '▼',
      dropdown: [
        { label: 'Laundry Detergents', link: '/special', img: 'https://via.placeholder.com/150?text=Laundry' },
        { label: 'Utensils Cleaner /Dishwash', link: '/special', img: 'https://via.placeholder.com/150?text=Cleaning' },
        { label: 'Household Cleaners & Freshner', link: '/special', img: 'https://via.placeholder.com/150?text=Cleaning' },
        { label: 'Cleaning Tools', link: '/special', img: 'https://via.placeholder.com/150?text=Cleaning' },
        { label: 'Insect Repellents', link: '/special', img: 'https://via.placeholder.com/150?text=Cleaning' },
        { label: 'Pooja/Devotional Products', link: '/special', img: 'https://via.placeholder.com/150?text=Cleaning' },
        { label: 'Miscellaneous', link: '/special', img: 'https://via.placeholder.com/150?text=Cleaning' },
        { label: 'Stationary', link: '/special', img: 'https://via.placeholder.com/150?text=Cleaning' },
      ]
    },
  ];

  const mobileMenus = menus.filter(menu => hiddenOnMobile.includes(menu.key) && menu.key !== "home");

  const navStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 20px',
    backgroundColor: '#fff',
    borderBottom: '1px solid #ddd',
    position: 'relative',
  };

  const wrapperStyle: React.CSSProperties = {
    position: 'absolute',
    top: '12px',
    right: '20px',
    padding: '6px 8px',
    borderRadius: '4px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  const iconStyle: React.CSSProperties = {
    fontSize: '20px',
    color: '#1877F2',
    transition: 'color 0.3s ease',
  };

  const itemBoxStyle: React.CSSProperties = {
    position: 'relative',
    border: '1px solid #ccc',
    padding: '8px 16px',
    borderRadius: '5px',
    cursor: 'pointer',
    backgroundColor: '#f7f7f7',
    display: 'inline-block',
    fontWeight: 600,
    fontSize: '14px',
  };

  const itemDropdownStyle: React.CSSProperties = {
    position: 'absolute',
    top: '100%',
    left: 0,
    backgroundColor: 'white',
    border: '1px solid #ccc',
    marginTop: '6px',
    padding: '10px 12px',
    width: '200px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 999,
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  };


  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState<string | null>(null);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    document.body.style.overflow = mobileMenuOpen ? "auto" : "hidden";
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleMouseEnter = (menu: string) => {
    setOpenSubMenu(menu);
  };

  // Function to close submenu on mouse leave
  const handleMouseLeave = () => {
    setOpenSubMenu(null);
  };



  const cartCount = buyDatas.length;

  const containerStyle: React.CSSProperties = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 600,
    color: '#1b1b1b',
  };

  const badgeStyle: React.CSSProperties = {
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    backgroundColor: '#00a1cb',
    color: 'white',
    borderRadius: '50%',
    padding: '2px 6px',
    fontSize: '10px',
    fontWeight: 'bold',
  };



  const subtotal: number = buyDatas.reduce((acc: number, item: BuyOrders) => {
    const price = parseFloat(item.SellingRate?.toString());
    return acc + price * item.productQty;
  }, 0);

  return (
    <>
      {/* Desktop Menu */}
      <nav className="navBar">
        <div className="logoLinkContainer">
          <div className="linkContainer">
            <ul>
              {/* Logo */}
              <li>
                <Link to="/" onClick={scrollToTop}>
                  <img
                    src={logo}
                    alt="Logo"
                    className="logo"
                    style={{ height: "80px", width: "200px" }}
                  />
                </Link>
              </li>

              {/* Home with Language Dropdown */}
              <FlagDropdown />


              {/* Login or Register - just text link */}


              {/* Specials - just text */}
              <li style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: '10px' }}>
                <FaGift size={18} color="white" />
                <Link to="/special">
                  <span style={{ color: "white", }}>SPECIALS</span>
                </Link>
              </li>

              {/* Account - dropdown with Login and Check your Order */}



              {/* 
              <li
                style={{ display: "flex", alignItems: "center", gap: "6px", color: "white" }}
              >
                <FaCashRegister size={18} />
                <Link to="/orderTracking">
                <span style={{ color: 'white' }}>CHECKOUT</span>
                </Link>
              </li> */}
              {/* Search, Icons */}
              <li style={{ marginLeft: '2px' }}>

                <CategoryDropdown />
              </li>

              {/* Cart - just text */}
              <li style={containerStyle}>
                <Link to="/cart" style={{ display: "flex", alignItems: "center", gap: "6px", color: "white", textDecoration: "none" }}>
                  <div style={{ position: "relative" }}>
                    <FaShoppingCart size={20} />
                    {cartCount > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-10px",
                          backgroundColor: "Red", // ✅ green badge
                          color: "white",
                          borderRadius: "50%",
                          padding: "2px 6px",
                          fontSize: "10px",
                          marginLeft: '10px'
                        }}
                      >
                        {cartCount}
                      </div>
                    )}
                  </div>
                  <span style={{ marginLeft: '12px', color: 'white', fontWeight: 'bold' }}>CART</span>
                  {/* <span> - ₹{subtotal ? subtotal.toFixed(2) : "0.00"}</span> */}
                </Link>
              </li>
             
             

              <li
                onMouseEnter={() => handleMouseEnter("account")}
                onMouseLeave={handleMouseLeave}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "white",
                    marginLeft: '10px'

                  }}
                >
                  <FaUserCircle size={18} />
                  {auth && auth?.length > 0 ? auth[0].membername : 'PROFILE'}
                </span>

                <ul className="dropdown">
                  {auth.length === 0 ? (
                    <li>
                      <Link
                        to="/loginSignUp"
                        onClick={scrollToTop}
                        style={{ display: "flex", alignItems: "center", gap: "6px", color: '#5e626b' }}
                      >
                        <FaSignInAlt size={14} />
                        LOGIN
                      </Link>
                    </li>
                  ) : (
                    <li style={{ listStyle: "none" }}>
                      <div
                        onClick={handleLogout}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          color: "#5e626b",
                          cursor: "pointer",
                          fontSize: "11px",
                          lineHeight: "1",
                          fontFamily: "inherit",

                        }}
                      >
                        <FaSignOutAlt size={14} style={{ marginLeft: '10px' }} />
                        <span style={{ fontSize: "9px", marginLeft: '2px', color: '#5e626b' }}>LOGOUT</span>
                      </div>
                    </li>
                  )}

                  <li>
                    <Link
                      to="/orders"
                      onClick={scrollToTop}
                      style={{ display: "flex", alignItems: "center", gap: "6px", color: '#5e626b' }}
                    >
                      <FaClipboardList size={14} />
                      CHECK YOUR ORDER
                    </Link>
                  </li>
                </ul>
              </li>





            </ul>
          </div>



        </div>
      </nav>

      {/* Mobile Menu */}
      <nav>
        <div className="mobile-nav">
          {mobileMenuOpen ? (
            <MdOutlineClose size={22} onClick={toggleMobileMenu} />
          ) : (
            <RiMenu2Line size={22} onClick={toggleMobileMenu} />
          )}

        </div>
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-menuTop">

            <div className="mobile-menuList">
              <ul>
                {mobileMenus.map((menu) => (
                  <li key={menu.key}>
                    {menu.dropdown ? (
                      <>
                        <div
                          onClick={() =>
                            setOpenAccordion(openAccordion === menu.key ? null : menu.key)
                          }
                          style={{ cursor: "pointer", fontWeight: "600", padding: "10px 20px" }}
                        >
                          {menu.label} {openAccordion === menu.key ? "▲" : "▼"}
                        </div>{openAccordion === menu.key && (
                          <ul style={{ paddingLeft: 20 }}>
                            {menu.dropdown.map((item, i) => (
                              <li key={i} style={{ padding: "8px 0" }}>
                                {item.link ? (
                                  <span
                                    style={{ cursor: "pointer", color: "#007BFF" }}
                                    onClick={() => {
                                      if (item.link) {
                                        navigate(`/special?subLabel=${encodeURIComponent(item.label)}`, { state: { subLabel: item.label } })
                                        toggleMobileMenu();
                                      }
                                    }}
                                  >
                                    {item.label}
                                  </span>
                                ) : (
                                  <span>{item.label}</span>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}

                      </>
                    ) : (
                      <Link
                        to={menu.link ?? "#"}
                        onClick={toggleMobileMenu}
                        style={{ padding: "10px 20px", display: "block" }}
                      >
                        {menu.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mobile-menuFooter">
            <div className="mobile-menuFooterLogin">
              <Link to="/loginSignUp" onClick={toggleMobileMenu}>
                <FaRegUser />
                <p style={{ marginTop: "5px" }}>{auth.length > 0 ? auth[0].membername : 'Login'}</p>
              </Link>
              {auth.length > 0 && (
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <FaRegUser />
                  <p style={{ marginTop: "5px" }} onClick={() => { handleLogout(); toggleMobileMenu() }}>Logout</p>
                </div>
              )}




              <Link to="/cart" onClick={toggleMobileMenu} style={{ position: 'relative' }}>
                <FaCartShopping size={20} />
                {cartCount > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    background: 'red',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '2px 6px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    {cartCount}
                  </span>
                )}
                <p style={{ marginTop: '5px' }}>Cart</p>
              </Link>

              <Link to="/orders" onClick={toggleMobileMenu}>
                <FaCartShopping />
                <p style={{ marginTop: "5px" }}>Check your Order</p>
              </Link>


            </div>
            <div className="mobile-menuFooterLangCurrency">
              <div className="mobile-menuFooterLang">

                <FlagDropdown />
              </div>
              <div className="mobile-menuFooterCurrency">
                <Link to={'/'} onClick={toggleMobileMenu}><label htmlFor="home">Home</label></Link>

              </div>
            </div>
            <div className="mobile-menuSocial_links">
              <FaFacebookF />
            </div>
          </div>
        </div>
      </nav>



      <div className="movingTextContainer">
        <div className="movingText">
          <h2 style={{ fontSize: "15px", color: "red" }}>
            Dear Customers, Sorry for the inconvenience. We are upgrading our Online
            Store, due to that our products & prices are not displaying correctly
            here. It might change after placing the order. We are Hiring. Job
            Application:{" "}
            <a href="https://forms.gle/RWrX8sKJsPPVHBwJ7" target="_blank" rel="noopener noreferrer">
              Click here to apply
            </a>
            .
          </h2>
        </div>
      </div>

      <CustomNavbar isMobile={isMobile} mobileMenuOpen={mobileMenuOpen} />
    </>
  );
};

export default Navbar;




